import { Theme } from '@emotion/react'
import { ThemeDocument } from '../../types.generated'
import { asText } from '@prismicio/client'
import styled from '@emotion/styled'

export const VERTICAL_ELEMENT_MARGIN_BOTTOM_DESKTOP = '2em'
export const VERTICAL_ELEMENT_MARGIN_BOTTOM_MOBILE = '1.4em'

export const OVERLAY_TEXT_BOX_PADDING = '2em'
export const OVERLAY_TEXT_BOX_MAX_WIDTH = '450px'

export const GlobalThemeContainer = styled.div`
  // Important to override dark theme on android devices
  background-color: ${({ theme }) =>
    theme.backgroundColor || 'white'} !important;

  ul, ol {
    list-style: revert;
  }

  * {
    overflow-wrap: break-word;
    hyphens: auto;

    color: black;
  }

  ${({ theme }) => `
    ${theme.fontFacesCss}
    ${theme.cssTheme}
  `}
`

export const mapTheme = (themeDocument: ThemeDocument): Theme => {
  const shouldUseFontFaces = themeDocument.data.font_faces_allowlist.some(
    (allowListEntry) =>
      allowListEntry.font_face_allow_url === null ||
      window.location.href.indexOf(allowListEntry.font_face_allow_url) > -1
  )

  return {
    backgroundColor: themeDocument.data.background_color ?? '',
    inlineElementAlign: themeDocument.data.inline_alignment || 'center',
    inlineTextMaxWidth: themeDocument.data.inline_text_max_width || '660px',
    inlineElementMaxWidth: themeDocument.data.inline_element_max_width || '979px',
    inlinePaddingLeftRightDesktop: themeDocument.data.inline_padding_leftRight_desktop || '20px',
    inlinePaddingLeftRightMobile: themeDocument.data.inline_padding_leftRight_mobile || '24px',
    cssTheme: asText(themeDocument.data.css_theme) ?? '',
    inlineCaptionCss: asText(themeDocument.data.inline_caption_css) ?? '',
    fontFacesCss: shouldUseFontFaces
      ? asText(themeDocument.data.font_faces_css)
      : '',
    headerHeightPortrait: themeDocument.data.header_height_portrait ?? 0,
    headerHeightLandscape: themeDocument.data.header_height_landscape ?? 0,
    scrollOverMediaCoverContainerCss:
      asText(themeDocument.data.scrollOverMedia_cover_container_css) ?? '',
    scrollOverMediaCoverCss:
      asText(themeDocument.data.scrollOverMedia_cover_css) ?? '',
    scrollOverMediaCoverCaptionCss:
      asText(themeDocument.data.scrollOverMedia_cover_caption_css) ?? '',
    scrollOverMediaTextboxesCss:
      asText(themeDocument.data.scrollOverMedia_textboxes_css) ?? '',
    quoteContainerCss: asText(themeDocument.data.quote_container_css) ?? '',
    quoteContentCss: asText(themeDocument.data.quote_content_css) ?? '',
    quoteTextCss: asText(themeDocument.data.quote_text_css) ?? '',
    quoteCaptionCss: asText(themeDocument.data.quote_caption_css) ?? '',
    foldoutContainerCss: asText(themeDocument.data.foldout_container_css) ?? '',
    foldoutTextCss: asText(themeDocument.data.foldout_text_css) ?? '',
    foldoutCaptionCss: asText(themeDocument.data.foldout_caption_css) ?? '',
    foldoutTitleCss: asText(themeDocument.data.foldout_title_css) ?? '',
    foldoutIcon: themeDocument.data.foldout_icon?.url ?? '',
    videoPlayIcon: themeDocument.data.video_play_icon?.url ?? '',
    videoControlsPrimaryCss: asText(themeDocument.data.video_primary_elements_css) ?? '',
    videoControlsSecondaryCss: asText(themeDocument.data.video_secondary_elements_css) ?? '',
    videoControlsSubtitlesCss: asText(themeDocument.data.video_subtitles_css) ?? '',
  }
}
